<template>
    <div class="full-screen">
        <ResultsLocationFullScreen :location="result" :rank="rank" />
    </div>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    const { isMobile } = useMobile()

</script>

<style scoped>

/* .full-screen {
    padding-bottom: 10px;
} */

</style>
